import {
  Permission as PermissionMaster,
  PIC_DEFAULT_PERMISSION,
  Role as RoleMaster,
} from '@master/core/enums';
import { UserProfile } from '@master/core/services/authentication.service';
import {
  DEFAULT_PERMISSION,
  Permission as PermissionTenant,
  Role as RoleTenant,
} from '@tenant/core/enums';
import { AdminProfile } from '@tenant/core/services/authentication.service';

export class Helper {
  static formatDate(date: Date | string): string {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.toLocaleDateString();
  }

  static formatDateTime(date: Date | string): string {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.toLocaleString();
  }

  static isEmpty(value: any): boolean {
    return value === null || value === undefined || value === '';
  }

  static async convertFile(url: string) {
    if (this.isEmpty(url)) return;

    try {
      const response = await fetch(url);

      if (!response.ok) return null;

      const blobFile = await response.blob();

      return new File([blobFile], '友だちリスト.csv', {
        type: blobFile.type || 'text/csv',
      });
    } catch (error) {
      return null;
    }
  }

  static checkAllowPermission(
    currentUser: UserProfile | AdminProfile | null,
    permission:
      | PermissionMaster
      | PermissionTenant
      | (PermissionMaster | PermissionTenant)[],
  ) {
    if (currentUser) {
      const role = currentUser.roles[0].name;
      const userPermission = currentUser.permissions.map((p) => p.name);
      switch (role) {
        case RoleMaster.ADMIN:
        case RoleTenant.MASTER_ADMIN:
        case RoleTenant.MASTER_PIC:
        case RoleTenant.ADMIN:
          return true;
        case RoleMaster.PIC:
          return [...userPermission, ...PIC_DEFAULT_PERMISSION].some((p) =>
            permission.includes(p),
          );
        case RoleTenant.MASTER_OPERATOR:
        case RoleTenant.OPERATOR:
        case RoleTenant.PIC:
          return [...userPermission, ...DEFAULT_PERMISSION].some((p) =>
            permission.includes(p),
          );

        default:
          return userPermission.some((p) => permission.includes(p));
      }
    }

    return false;
  }

  static downloadFile(data: any, fileName: string, isBom: boolean = true) {
    const bom = new Uint8Array([
      parseInt('EF', 16),
      parseInt('BB', 16),
      parseInt('BF', 16),
    ]);

    let finalData = new Uint8Array([...bom, ...new Uint8Array(data)]);

    if (!isBom) {
      finalData = new Uint8Array([...new Uint8Array(data)]);
    }

    const blob = new Blob([finalData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const nav = window.navigator as any;
    if (nav.msSaveOrOpenBlob) {
      nav.msSaveBlob(blob, `${fileName}.csv`);
    } else {
      const a = document.createElement('a');
      a.href = url;
      a.download = `${fileName}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }

    window.URL.revokeObjectURL(url);
  }

  static countCsvRows(result: string) {
    let inQuotes = false;
    let rowCount = 0;

    for (let i = 0; i < result.length; i++) {
      const char = result[i];
      if (char === '"') {
        if (inQuotes && result[i + 1] === '"') {
          i++;
        } else {
          inQuotes = !inQuotes;
        }
      }

      if (char === '\n' && !inQuotes) {
        rowCount++;
      }
    }

    return rowCount + 1;
  }
}
